/* Page panier LeMess — maj quantité / suppression en AJAX via Section Rendering. */
(function () {
  var root = document.getElementById('bd-cart-root');
  if (!root) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  var CHANGE_URL = ROOT.replace(/\/$/, '') + '/cart/change.js';

  function sectionId() {
    var s = document.querySelector('[data-bd-cart-id]');
    return s ? s.getAttribute('data-bd-cart-id') : null;
  }

  function updateHeaderCount(count) {
    var el = document.querySelector('[data-bd-cart-count]');
    if (!el) return;
    el.textContent = count;
    el.classList.toggle('is-empty', count === 0);
  }

  function setBusy(b) { root.classList.toggle('is-busy', b); }

  function change(line, quantity) {
    if (isNaN(line)) return;
    setBusy(true);
    var id = sectionId();
    var body = { line: line, quantity: quantity };
    if (id) { body.sections = [id]; body.sections_url = window.location.pathname; }

    fetch(CHANGE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (typeof data.item_count === 'number') {
          updateHeaderCount(data.item_count);
          if (data.item_count === 0) { window.location.reload(); return; }
        }
        var html = id && data.sections && data.sections[id];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('bd-cart-root');
          if (fresh) root.innerHTML = fresh.innerHTML;
        }
        setBusy(false);
      })
      .catch(function () { window.location.reload(); });
  }

  // Délégation (root persiste, son innerHTML est remplacé au refresh)
  root.addEventListener('click', function (e) {
    var rm = e.target.closest('.bd-cart-remove');
    if (rm) { e.preventDefault(); change(parseInt(rm.dataset.line, 10), 0); return; }

    var qb = e.target.closest('.bd-cart-qty-btn');
    if (qb) {
      e.preventDefault();
      var item = qb.closest('.bd-cart-item');
      var inp = item && item.querySelector('.bd-cart-qty-input');
      if (!inp) return;
      var v = parseInt(inp.value, 10) || 0;
      v = qb.dataset.action === 'plus' ? v + 1 : Math.max(0, v - 1);
      inp.value = v;
      change(parseInt(inp.dataset.line, 10), v);
    }
  });

  root.addEventListener('change', function (e) {
    var inp = e.target.closest('.bd-cart-qty-input');
    if (!inp) return;
    var v = parseInt(inp.value, 10);
    if (isNaN(v) || v < 0) v = 0;
    inp.value = v;
    change(parseInt(inp.dataset.line, 10), v);
  });
})();
